import request from './request'

export function cateList(query) {
    return request({
        url:'/huhuapi/stories/storyList',
        method: 'post',
        data: query
    });
}

export function storyDetail(query) {
    return request({
        url:'/huhuapi/stories/storyDetail',
        method: 'post',
        data: query
    });
}

export function getStoryAd(query) {
    return request({
        url:'/huhushare/Fissionvip/getStoryAd',
        method: 'post',
        data: query
    });
}

export function shareUnlockCate(query) {
    return request({
        url:'/huhuapi/stories/shareUnlockCate',
        method: 'post',
        data: query
    });
}



// WEBPACK FOOTER //
// ./src/api/album.js